import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import './Text.css';

const BODY_VARIANT = {
  'body-s': 'body2',
  'body-m': 'body1',
  'body-l': 'body1',
  h3: 'h3',
};

/**
 * Foundations text — Body S/M/L + H3 product scale.
 */
export function Text({
  variant = 'body-m',
  as,
  children,
  className = '',
  ...props
}) {
  const component = as || (variant === 'h3' ? 'h3' : 'p');
  return (
    <Typography
      component={component}
      variant={BODY_VARIANT[variant] || 'body1'}
      className={[
        'onyx-text',
        `onyx-text--${variant}`,
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-text"
      {...props}
    >
      {children}
    </Typography>
  );
}

Text.propTypes = {
  variant: PropTypes.oneOf(['body-s', 'body-m', 'body-l', 'h3']),
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Agate display heading (product + marketing scales).
 */
export function Heading({
  level = 2,
  children,
  className = '',
  ...props
}) {
  const tag = `h${level}`;
  return (
    <Typography
      component={tag}
      variant={tag}
      className={['onyx-heading', className].filter(Boolean).join(' ')}
      data-testid="onyx-heading"
      {...props}
    >
      {children}
    </Typography>
  );
}

Heading.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4]),
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Fragment Mono uppercase eyebrow label.
 */
export function Eyebrow({ children, className = '', ...props }) {
  return (
    <span
      className={['onyx-eyebrow', className].filter(Boolean).join(' ')}
      data-testid="onyx-eyebrow"
      {...props}
    >
      {children}
    </span>
  );
}

Eyebrow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Text;
